import clsx from 'clsx';

import Link from '~/src/common/components/Link';
import I18n from '~/src/common/services/I18n';
import { Image, ImageParams } from '~/src/common/typings/image';
import { getImageUrlFromFormat } from '~/src/common/utils/cloudinary';
import type { useProductLink } from '~/src/screens/CatalogContent/ContentScreen/hooks/catalogContentLinks';

import styles from './ProductImageLink.module.scss';

interface Props extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
  productLink: ReturnType<typeof useProductLink>;
  images: Image[];
  isAvailable?: boolean;
  dimensions?: {
    width: number;
    height: number;
  };
  showOutStockTag?: boolean;
}

const ProductImageLink = ({
  images,
  productLink,
  isAvailable = true,
  dimensions,
  showOutStockTag = true,
  ...anchorProps
}: Props) => {
  const { as, query } = productLink;

  if (images == null) return null;

  const imageUrl = getImageUrlFromFormat(images[0], 'card_ratio', ImageParams.productListItem);

  return (
    <Link className={styles.link} href={{ pathname: as, query }} as={as} {...anchorProps}>
      <img
        className={clsx(styles.image, !isAvailable && styles.unavailable)}
        src={imageUrl}
        alt={images[0]?.name}
        style={dimensions}
      />

      {!isAvailable && showOutStockTag ? (
        <span className={styles.outOfStock}>{I18n.t('product-list-item.out-stock')}</span>
      ) : null}
    </Link>
  );
};

export default ProductImageLink;
